// Search for the e-sign form library (Grant, 2026-10-27: "there needs to be a
// search bar so there is not a requirement to search through every form").
// Realty's library is 70+ AAR forms long, so scrolling to find one is the
// slowest step of starting a package.
//
// Pure so it can be tested without rendering the wizard.

export interface SearchableForm {
  id: string;
  name: string;
  publisher?: string | null;
  revisionLabel?: string | null;
}

/** Lower-case, strip punctuation, so "Buyer's" matches "buyers". */
function normalize(text: string): string {
  return text
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/**
 * Forms whose name, publisher or revision contain EVERY word typed, in any
 * order ("commission auth" finds "Commission Disbursement Authorization").
 *
 * DECISION: a form that is already ticked always stays in the list, even when
 * it no longer matches. Hiding a ticked form would let someone send a package
 * with a document in it they can no longer see.
 */
export function filterLibraryForms<T extends SearchableForm>(
  forms: readonly T[],
  query: string,
  keepIds: readonly string[] = [],
): T[] {
  const words = normalize(query).split(" ").filter(Boolean);
  if (words.length === 0) return [...forms];
  const keep = new Set(keepIds);
  return forms.filter((f) => {
    if (keep.has(f.id)) return true;
    const hay = normalize([f.name, f.publisher ?? "", f.revisionLabel ?? ""].join(" "));
    return words.every((w) => hay.includes(w));
  });
}
